import React, { useEffect, useState } from "react";
import { Toast, ToastBody } from "reactstrap";
import { registerToast } from "./customToast";
import "../assets/css/--component-toaster.css";
import successIcon from "../assets/images/suucessIcon.png";
import heartIcon from "../assets/images/heart.png";
import errorIcon from "../assets/images/error-icon.png";
import { useCart } from "../context/cartProvider";
import { useNavigate } from "react-router-dom";
export default function ToastContainer() {
  const [toast, setToast] = useState(null);
  const history = useNavigate();
  const {openCart} = useCart();
  useEffect(() => {
    registerToast((data) => {
      setToast(data);
      setTimeout(() => setToast(null), 3000);
    });
  }, []);

  if (!toast) return null;

  const handleOpenCart = () => {
    history("/menu");
    openCart();

  };

  return (
    <div className="app-toast-wrapper">
      <Toast>
        <ToastBody className={`app-toast-body ${toast.type}`}>
          <img
            src={toast.type === "success" || toast.type === "info" ? successIcon : toast.type === "wish" ? heartIcon : "" || toast.type === "error" ?  errorIcon : ""}
            className={`toast-icon ${toast.type}`}
            alt="icon"
          />
          <div className={`toast-content ${toast.type}`}>
            <h6>{toast.title}</h6>
            {toast.description && <p>{toast.description}</p>}
          </div>
          {/* {toast.type === "wish" &&
            <a href={`${toast.link}`} className="toast-link">
              VIEW WISHLIST →
            </a>
          }   */}
          {toast.link  &&
            <a onClick={toast.link === "/openCart" ? handleOpenCart : ()=>history(toast.link)} className="toast-link">
              {toast.type == "wish" ? "VIEW WISHLIST →" : "VIEW CART →"}
            </a>
          }
        </ToastBody>
      </Toast>
    </div>
  );
}
